export default __webpack_public_path__ + "navigation-examples-basic-thumbnail-960-afe12957bef3f3be6496fad9e599fddf.png";